import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "login-wrapper" }
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = { class: "login-card" }
const _hoisted_4 = { class: "form-group mb-4" }
const _hoisted_5 = { class: "input-container" }
const _hoisted_6 = { class: "form-group mb-4" }
const _hoisted_7 = { class: "input-container" }
const _hoisted_8 = {
  key: 0,
  class: "error-banner mb-3"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-header text-center" }, [
          _createElementVNode("h2", { class: "auth-title" }, "Admin Sign In"),
          _createElementVNode("p", { class: "auth-subtitle" }, "Please enter your credentials to access the dashboard")
        ], -1)),
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"])),
          class: "login-form"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("label", {
              for: "email",
              class: "form-label"
            }, "Email Address", -1)),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                id: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                placeholder: "email@example.com",
                class: "form-input",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.email]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("label", {
              for: "password",
              class: "form-label"
            }, "Password", -1)),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                placeholder: "••••••••",
                class: "form-input",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.password]
              ])
            ])
          ]),
          (_ctx.errorMsg)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorMsg), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "submit",
            disabled: _ctx.loading,
            class: "btn-submit"
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10))
              : _createCommentVNode("", true),
            _cache[5] || (_cache[5] = _createTextVNode(" Sign In "))
          ], 8, _hoisted_9)
        ], 32)
      ])
    ])
  ]))
}